module.exports = __webpack_public_path__ + "static/media/COS_LOADING.0312d7be.svg";